// extracted by mini-css-extract-plugin
export var chevron = "_ls-2";
export var chevronRotated = "_ls-3";
export var header = "_ls-1";
export var section = "_ls-0";